import SEO from "@/components/SEO";
import { Reveal, SectionHeading } from "@/components/Reveal";
import HowItWorksSection from "./home/HowItWorksSection";
import CtaBand from "./home/CtaBand";

export default function HowItWorks() {
  return (
    <>
      <SEO
        title="Cum funcționează — de la cerere la recepție | BROX CONSTRUCT"
        description="Cinci pași: spui ce ai nevoie, analizăm proiectul, stabilim soluția, executăm și coordonăm, apoi facem recepția lucrării. Un singur contact, tot proiectul."
        path="/cum-functioneaza"
      />
      <section className="grain bg-ink-950 pb-10 pt-28 sm:pb-20 sm:pt-40">
        <div className="container-brox">
          <Reveal><p className="eyebrow mb-5">PROCESUL BROX</p></Reveal>
          <SectionHeading
            title={<>De la „am nevoie de o renovare"<br /><span className="text-copper">la cheie primită.</span></>}
          />
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
              Nu trebuie să cauți, să verifici și să coordonezi zece meseriași. Tu ai un singur interlocutor —
              Brox Construct. Restul îl organizăm noi, cu echipele și furnizorii potriviți. Pentru proiectele
              unde este necesar, facem o evaluare la fața locului înainte de oferta finală.
            </p>
          </Reveal>
        </div>
      </section>
      <HowItWorksSection />
      <CtaBand />
    </>
  );
}
